import React from 'react'
import { Container } from '@kogk/common'
import { ButtonDep as Button } from '..'
import { Fade } from 'react-reveal'

const Email = ({ email, lang }: { email: string; lang: string }) => {
  const prettyEmail = email.replace('@', lang === 'en' ? '[at]' : '[hjá]')

  return (
    <a href={`mailto:${email}`}>
      <Button type='secondary' label={prettyEmail} />
    </a>
  )
}

export interface EmployeeType {
  full_name: string
  role: string
  bio: {
    html: string
  }
  email?: string
  image: {
    alt: string
    url: string
  }
}
const EmployeeBox: React.FC<{
  employee: EmployeeType
  lang: string
}> = ({ employee, lang }) => {
  return (
    <Fade up distance='10px' duration={350}>
      <div>
        <div className='completeCenter overflow-hidden border image-rounded'>
          <div className='imageBox' aria-label='Employee info'>
            <img src={employee.image.url} alt='Employee' />
          </div>
        </div>
        <div className='info py-2 parag'>
          <h5>{employee.full_name}</h5>
          <p className='mb-1 parag--sm'>{employee.role}</p>
          {employee.email && <Email lang={lang} email={employee.email} />}
        </div>
      </div>
    </Fade>
  )
}

const StaffGrid: React.FC<{ members: EmployeeType[]; title?: string; lang?: string }> = ({
  members,
  title,
  lang = 'en'
}) => {
  return (
    <Container className='py-1 py-md-3'>
      <h3 className='mb-3'>{title === undefined ? 'Staff' : title}</h3>
      <div className='staff-grid'>
        {members.map((member, idx) => (
          <EmployeeBox key={idx} employee={member} lang={lang} />
        ))}
      </div>
    </Container>
  )
}

export default StaffGrid
